<!--NOTE: This component has been deprecated-->

<div class="action-bar" [ngClass]="grayBackground ? 'gray' : ''">
  <div *ngIf="!mobile" class="action-bar-logo-box">
    <img *ngIf="logo" class="action-bar-logo" [src]="logo" alt="logo" />
    <svg
      *ngIf="!logo"
      class="action-bar-logo"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 300 300"
      style="enable-background: new 0 0 300 300"
      xml:space="preserve"
    >
      <g id="c" transform="translate(0 0)">
        <path
          id="Path_2"
          d="M162.77,1.36C80.68-5.81,8.32,54.92,1.14,137.01S54.7,291.47,136.8,298.64s154.46-53.56,161.63-135.65
                c0,0,0,0,0-0.01C305.59,80.89,244.86,8.53,162.77,1.36z M94.93,252.89c-34.3-3.01-49.42-23.94-56.81-36.4
                C1.34,154.89,21.45,75.14,83.04,38.36c19.2-11.46,41.02-17.78,63.38-18.33c-1.56,0.54-17.37,9.17-19.39,32.17
                c-1.89,21.61,11.51,41.27,22.18,60.3c2.74,4.9,5.26,9.44,8.54,15.18c8.75,15.51,18.19,36.43,16.23,58.91
                c-3.52,40.13-38.89,69.82-79.02,66.32L94.93,252.89z M195.48,225.75c-3,34.33-33.06,54.67-66.82,51.73
                c-7.79-0.7-15.46-2.41-22.82-5.08c42.13-2.14,77.46-32.52,85.89-73.85C195,207.22,196.28,216.51,195.48,225.75z M279.28,161.29
                c-0.98,11.61-3.54,23.03-7.63,33.94c1.59-18.97-5.47-62.55-45.96-94.8c-2.74-2.2-9.89-7.88-15.3-12.2
                c-19.87-15.8-35.53-25.81-34.18-41.34c0.9-9.5,9.34-16.48,18.84-15.58c0.2,0.02,0.4,0.04,0.6,0.07
                c18.97,1.66,39.41,20.59,39.41,20.59c31.31,27.33,47.72,67.95,44.19,109.37L279.28,161.29z"
        />
      </g>
    </svg>
  </div>
  <div *ngIf="!mobile && displayTitle" class="action-bar-title-div">
    <h5 class="action-bar-title">{{ applicationTitle }}</h5>
  </div>
  <div class="flex-container" [class.space-between]="spaceCount > 2">
    <div
      *ngIf="mobile"
      [class]="menuThemeColor"
      [class.selected]="homeSelected"
      class="icon-home action-bar-home-icon"
      (click)="homeClicked()"
    ></div>

    <div
      *ngIf="mobile && searchIcon"
      class="icon-search action-bar-search-icon"
      (click)="searchClicked()"
      [class]="menuThemeColor"
      [class.selected]="searchIsActive"
    ></div>

    <div *ngIf="!mobile" class="action-bar-controls">
      <ng-content select="[actionBarControls]"></ng-content>
    </div>

    <div *ngIf="!mobile && dropdownMenuSelector" class="action-bar-dropdown">
      <div
        *ngIf="dropdownMenuItems.length > 1"
        (click)="dropdownMenuSelector.toggle($event)"
        class="action-bar-dropdown-menu"
      >
        {{ selectedDropdownMenuItem?.label }}&nbsp;<span
          class="icon-arrow-drop-down"
        ></span>
      </div>
      <div
        *ngIf="dropdownMenuItems.length === 1"
        class="action-bar-dropdown-menu no-dropdown"
      >
        {{ selectedDropdownMenuItem?.label }}
      </div>
      <p-menu
        #dropdownMenuSelector
        [popup]="true"
        appendTo="body"
        [model]="mappedDropdownMenuItems"
        styleClass="action-bar-dropdown-menu-selector"
      ></p-menu>
    </div>

    <div
      *ngIf="!mobile && activeUsers"
      [ngClass]="{
        'action-bar-active-users': userProfiles && userProfiles.length > 0
      }"
    >
      <basin-user-avatar-group [users]="userProfiles"></basin-user-avatar-group>
    </div>

    <div
      *ngIf="notificationsBell"
      class="action-bar-notification-bell"
      [class]="menuThemeColor"
      [class.selected]="notificationsIsOpen"
    >
      <div
        *ngIf="
          notifications != undefined &&
          notifications.length < 1 &&
          badgeValue == undefined
        "
        class="icon-notifications bell"
      ></div>
      <div
        *ngIf="
          (notifications != undefined && notifications.length > 0) || badgeValue
        "
        (click)="notificationPanel.toggle($event)"
        [ngClass]="mobile && badgeValue.length >= 2 && 'basin-mr-1'"
        class="icon-notifications bell"
        pBadge
        [value]="badgeValue"
      ></div>
      <p-overlayPanel
        styleClass="action-bar-notification-panel"
        #notificationPanel
        (onShow)="notificationsIsOpen = true"
        (onHide)="notificationsIsOpen = false"
      >
        <ng-template pTemplate>
          <div *ngIf="!customNotifications">
            <div class="action-bar-notifications-header basin-subtitle-large">
              Notifications
            </div>
            <div
              *ngFor="let notification of notifications"
              class="action-bar-notification-list-item"
            >
              {{ notification }}
            </div>
          </div>
          <ng-content
            *ngIf="customNotifications"
            select="[notificationWindow]"
          ></ng-content>
        </ng-template>
      </p-overlayPanel>
    </div>

    <div
      *ngIf="ellipsesMenu"
      [ngClass]="mobile ? 'icon-settings' : 'icon-more-horiz'"
      class="action-bar-ellipses"
      [class]="menuThemeColor"
      [class.selected]="ellipsesMenuIsOpen"
      (click)="ellipsesMenu.toggle($event)"
    >
      <p-menu
        #ellipsesMenu
        [popup]="true"
        [model]="ellipsesMenuItems"
        appendTo="body"
        (onShow)="ellipsesMenuIsOpen = true"
        (onHide)="ellipsesMenuIsOpen = false"
      ></p-menu>
    </div>

    <div
      *ngIf="showProfile"
      class="action-bar-user"
      (click)="
        profileMenuItems?.length > 0 ? profileMenu.toggle($event) : false
      "
    >
      <img
        *ngIf="profileImage && profileImage !== ''"
        [src]="profileImage"
        class="action-bar-profile-image"
        alt=""
      />
      <div
        class="action-bar-user-overlay"
        [class.user-icon]="!profileImage || profileImage === ''"
      ></div>
      <div
        *ngIf="mobile && (!profileImage || profileImage === '')"
        [ngClass]="'icon-person'"
        class="action-bar-user-icon"
        [class.selected]="profileMenuIsOpen"
      ></div>
      <basin-circled-icon
        *ngIf="!mobile && (!profileImage || profileImage === '')"
        size="medium"
        icon="icon-person"
        iconColor="var(--neutral-color-mid-gray)"
        backgroundColor="var(--neutral-color-lightest-gray)"
      ></basin-circled-icon>
      <p-menu
        #profileMenu
        [popup]="true"
        [model]="profileMenuItems"
        appendTo="body"
        (onShow)="profileMenuIsOpen = true"
        (onHide)="profileMenuIsOpen = false"
      ></p-menu>
    </div>

    <div
      *ngIf="mobile && dropdownMenuSelector"
      class="basin-display-flex basin-align-items-center"
    >
      <div
        [class]="menuThemeColor"
        class="icon-domain-add action-bar-dropdown-icon"
        [class.selected]="dropdownMenuIsOpen"
        (click)="dropdownMenuSelector.toggle($event)"
      ></div>
      <p-menu
        #dropdownMenuSelector
        [popup]="true"
        appendTo="body"
        [model]="mappedDropdownMenuItems"
        styleClass="action-bar-dropdown-menu-selector"
        (onShow)="dropdownMenuIsOpen = true"
        (onHide)="dropdownMenuIsOpen = false"
      ></p-menu>
    </div>
  </div>
</div>

<basin-searchbox
  class="mobile-searchbox"
  *ngIf="searchIsActive"
  [searchString]="searchString"
  (searchStringChange)="searchStringChanged($event)"
  (searchEntered)="searchEnter($event)"
></basin-searchbox>
